import React from "react";
import { WarrantyTabs } from "./Warranty";
import "./warranty.css";

/** The "Acceptance & warranty" tab of a project's page. */
const ProjectWarrantyPanel = ({ project }) => (
  <div className="warranty-page wty-project-panel">
    <WarrantyTabs project={project} />
  </div>
);

export default ProjectWarrantyPanel;
